import { useCallback } from 'react';
import { ArrowSection, BackArrowIcon } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { useHistory } from 'react-router-dom';
import { ICON_SIZE } from '../../global/constants';

export default function BackForwardIcon() {
  const history = useHistory();

  const onClickBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const onClickForward = useCallback(() => {
    history.goForward();
  }, [history]);

  return (
    <>
      <ArrowSection>
        <BackArrowIcon role='button' onClick={onClickBack}>
          <SVGIcon
            name='back-arrow'
            width={ICON_SIZE.MD}
            height={ICON_SIZE.MD}
            viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
            fill='var(--text-secondary)'
          />
        </BackArrowIcon>
        <BackArrowIcon role='button' onClick={onClickForward}>
          <SVGIcon
            name='back-arrow'
            width={ICON_SIZE.MD}
            height={ICON_SIZE.MD}
            viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
            className='forward-icon'
            fill='var(--text-secondary)'
          />
        </BackArrowIcon>
      </ArrowSection>
    </>
  );
}
